import { render, staticRenderFns } from "./VInbox.vue?vue&type=template&id=a68c674a"
import script from "./VInbox.vue?vue&type=script&lang=js"
export * from "./VInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports